export default __webpack_public_path__ + "static/media/BD_image.d238d267.jpg";